export const isMultiline = (value) => {
  return /\r?\n/.test(value);
};
